import { publish, JUTRO_TOPICS } from '@jutro/events';
import { v4 as generateGuid } from 'uuid';
import TransportService from './TransportService';
import RecaptchaUtil from '../../../applications/quote-and-buy/src/customer/modules/gw-portals-util-alfa/RecaptchaUtil';

let currentRequestIdCounter = 0;

const uuidForAllJsonRPCRequestsOfThisAppLoad = generateGuid();

const headers = {
    'Content-Type': 'application/json; charset=utf-8'
};
const httpTimeout = 90000;
export default class JsonRPCService {
    /**
     * Sends the JSON-RPC request to the given endpoint.
     * @param {string} serviceEndpoint - The service endpoint
     * @param {string} method - The RPC method to invoke
     * @param {Array} params - The parameters to invoke the service with
     * @param {Object} [additionalHeaders] - Additional headers to pass to the backend
     * @returns {Promise} - The promise from the remote call
     */
    static async send(serviceEndpoint, method, params, additionalHeaders = {}) {
        publish(JUTRO_TOPICS.FETCH_REQUEST, {
            serviceEndPoint: serviceEndpoint,
            method: method,
            params: params
        });
        const callStart = new Date().getTime();
        currentRequestIdCounter += 1;

        const jsonRPCid = `${uuidForAllJsonRPCRequestsOfThisAppLoad}_${currentRequestIdCounter}`;

        const body = JSON.stringify({
            id: `${jsonRPCid}`,
            jsonrpc: '2.0',
            method,
            params
        });
        const token = await RecaptchaUtil.fetchRecaptchaToken();
        const reCaptchaHeader = { reCaptchaToken: token };

        return (
            // eslint-disable-next-line max-len
            TransportService.send(serviceEndpoint, body, { ...headers, ...additionalHeaders, ...reCaptchaHeader })
                .then((response) => {
                    publish(JUTRO_TOPICS.FETCH_RESPONSE, {
                        serviceEndPoint: serviceEndpoint,
                        method: method,
                        params: params,
                        response: response
                    });

                    if (response.errorCode !== undefined) {
                        const callTime = new Date().getTime() - callStart;
                        response.gwInfo = {
                            serviceEndPoint: serviceEndpoint,
                            method: method,
                            params: params,
                        };
                        response.appErrorCode = null;
                        response.isUnauthenticated = (response.status === 401);
                        response.isTimeout = (response.status === 0) && callTime < httpTimeout;
                    }

                    return response;
                })
                .catch((error) => {
                    publish(JUTRO_TOPICS.FETCH_ERROR, {
                        serviceEndPoint: serviceEndpoint,
                        method: method, 
                        params: params,
                        error: error
                    });
                    if (TransportService.isSessionExpiredReason(error)
                        || TransportService.isUserUnauthenticatedReason(error)) {
                        /* refresh the page to get to login page
                         * Set reload to true. Some "authentication solutions" does not set proper
                         * caching headers.
                         */
                        window.location.reload(true);
                    }
                    // eslint-disable-next-line no-param-reassign
                    error.gwInfo = {
                        serviceEndPoint: serviceEndpoint,
                        method: method,
                        params: params,
                    };
                    throw error;
                })
        );
    }
}
